export default __webpack_public_path__ + "static/media/pexels-lex-photography-1109541 1.3f213944.jpg";